<script lang="ts">
  import RichAlert from '@packages/ui/main/rich-alert/RichAlert.svelte'
  import { pageOptsStore } from '@packages/stores'
  import { onDestroy } from 'svelte'
  import { TRichAlertButtonConfig } from '@packages/utils/types'

  let richAlertData: {
    description: string
    title: string
    actions?: TRichAlertButtonConfig[] | undefined
  }

  const unsub = pageOptsStore.subscribe((data) => {
    richAlertData = { ...richAlertData, ...data.richAlertData }
  })

  onDestroy(unsub)
</script>

<RichAlert
  options={{
    title: richAlertData.title || 'Notification',
    description: richAlertData.description || 'Choose your next steps',
    actions: richAlertData.actions,
  }}
/>
